export default "__VITE_ASSET__o2YYRx40__"